import type { ExternalIdChangeData } from '@festina/legalentity-general-types/legalentity'
import { PersonsService } from '@festina/legalentity-general-types/legalentity/services/PersonsService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { PersonActionProps } from '../types'

const method = PersonsService.legalEntitiesPersonServiceV3PutUpdateExternalId

type TriggerProps = ExternalIdChangeData

export const useCreateExternalIdChangeDataPerson = ({
  tenantId,
  personId,
}: PersonActionProps) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles: PersonsService.legalEntitiesPersonServiceV3PutUpdateExternalId_roles,
    isScenario: false,
    mutateFunction: async (requestBody: TriggerProps) => {
      await method({
        xTenantId: tenantId,
        personId,
        requestBody: { ...requestBody, _type: 'ExternalIdChangeData' },
      })
    },
  })
